import { works } from './global';
import { elements } from './base';

const SubNavigation = () => {
  const pathStrings = window.location.pathname.split(/(\/|\.)/);
  const numItems = works.length;
  const itemsIndex = [];

  // 1. Retrieve the index of nav-items
  works.forEach((work, index) => {
    if (pathStrings.includes(work.name)) {
      index
        ? itemsIndex.push(
            // Show one previous, two next works
            (index - 1) % numItems,
            (index + 1) % numItems
          )
        : itemsIndex.push(index + 1, index + 2); // for 1st work, show next three design works
    }
  });

  // 2. Retrieve nav-items
  const items = itemsIndex.map((index) => works[index]);

  // 3. Build HTML markup
  const markup = items
    .map((item) => {
      return `
      <div class="sub-nav__item">
        <a class="sub-nav__link" href="${item.name}.html">
            ${
              item.private
                ? '<svg><use xlink:href="assets/images/sprite.svg#icon-lock"></use></svg>'
                : ''
            }
            <img
              srcset="
                assets/images/works-landscape/${item.name}@1x.jpg 720w,
                assets/images/works-landscape/${item.name}@2x.jpg 1440w,
                assets/images/works-landscape/${item.name}@3x.jpg 1920w
              "
              sizes="(max-width: 50em) 45vw, (max-width: 75em) 30vw, 340px"
              src="assets/images/works-landscape/${item.name}@2x.jpg 2x"
              class="sub-nav__image"
              alt=${item.name}
            />
            <div class="sub-nav__text">
                <span class="sub-nav__text--title">${item.title}</span>
                ${item.subTitle}
            </div>
        </a>
      </div>
      `;
    })
    .join('');

  // 5. Add elements in the DOM
  elements.subNavigation.insertAdjacentHTML('afterbegin', markup);
};

export default SubNavigation;
